<template>
	<div class="login"><img :src="pageData.bg_image" class="background-img">
		<!-- <div class="title">2024年强基三一笔试真题联考</div>
		<div class="title-line"></div> -->
		<div class="login-box"><img :src="pageData.logo" class="logo">
			<div class="login-form">
				<div class="login-title">
					<div style="position: relative;"><img
							src="data:image/webp;base64,UklGRvIEAABXRUJQVlA4WAoAAAAQAAAAywIABQAAQUxQSJoCAAAJ8FXbtm1bkiTVtva/iDAUCA8EVxXBC4EWRagCYK/+seY+Kp/nMyImQK/Xdb26Xtfz1es6vrpe1/N1fX51va7jq9d1vXr1uq5ycalUuuRScsWVSxVdSUfpqFLpkiqVi46qVKqUKlUuLhdVqvT053//8L3547efZtvMvY3bNttsdpvbnmbb3Oae2TbbZpu5N7u5bbbZNjtyz+Y222ZH9rTbbLNttvt+3/d9v/fee+/7fd/33nvf9/3efb/v5/s+vvfe+977vfu+3/d93+/77gpyXvMxx42RJuflOYMm8sUlEmUNpjYfR7HNF7dhElMwZv7iBpOQIVu//Pbje+MfP37Ox1UR2Ty3nBPzjBWM+TijiciXS1ZYntmkbCPyxdiGSTNKDNqcyzOtJjai8rFTbCc7ZKxZjVHBYD7PHlHbZpgk83HqwYzEDlHOtzA2hCEbOsUcp2HI1Pj9e+NXxg42Hytt0xgjcx4ZEz02jERz7tFs87FgpgwK5v/N5+W5NvKMbLMewwaDOUfzjKmQ5zCplS3yeVIYg4JM5NmGyTBiGDnOyHFYaHNMGGETdmieST5mMPkGTWT06bnKmmCb82ILk2einBc9Ro2IRp4LQ9jyV04s2GOEm2lM0R5ZeYZ8vDPHEYxJcp5txWDbUGtm6LGFjWFBZskzbJ6hLGrYCG3z1SDnDIUYxuyxPGPMf743/o1tTBr2mPmYJarHGEJthkXbbDA22EYIY0aehfkc2mGGpmbycSWa8/K5ewY5bxvKHDeEOYclNp/rsVi+mHkOOa/EfViEGEaDRrCci1WzmFgkDJsWlh55Nsr//v7H98bf/vknRZCVGTEE89VLwWYi5Bg9jiNtjqNquA9zrseG9ViMMTTHwmKaPTJi4yJG9gBWUDggMgIAAFAOAJ0BKswCBgAAAAAlpAA6c4I12tEUH9+E2RtVp3J7X5sC7y+lrspyxJsdvFsKIbq5AJYrpVsCizftXjOmt1U9y8jTqB26ujaJjTaJjTbM/vpmacVK83NYwUFAIvo3akx1FLYCsJzfRX0pjS/CPJReoLX7aRLzuCnYAAD+//++Om2022qBcjGfWHz8/79vmZQbSXthySZ2xnTyiQCEafLOagux8nzCh9o3Mo3h+ntV7/6oCacrbuLmbmHzjs84Om62x/NPRHu01StajGoBwuZd4xhTI7cmkVyUBLso5OZ/R4CSaG28tm9gMKF+IxhSyI3dsklEvXDp4hbQKglyPizwS271/UzSgERdRVe05qk1ME2Sc8TYAniU0ir54QNF40ksrzmD5cYFQnXQjGmeokxtGXq6YOgSiYIRYHaLA4pnJ8tW/rlY+BuqBfy29flsZ0/VaPBVFP6wt///2SqqRIjYoAPj/sRzGOpKGMK0uguPFOz0Bpqo4b6D3biykNRi+2CtZie52l7rFLaQGGzI/UOVuZRZxsAiO7wmNjN62u07ERHhiibWAYsjGMU2nt4o1Op0/Ww2hSitPE0JqSMcNBiMkafRXBGaXEoGvxE5GtbqHnl8Txed/NYB6aABS/89amBHsDILvHm/ZaSLFSpmBs405pLgOdHtp2jC7zshRXkwR/rLTX+10EDvHdSFBKrA3Pinaj+Sc42YxiP2pid+1HjlipLRhhuodbmDxkRsU0uAAAA="
							class="decorator-line">
						<div class="title" :style="type == 1 ? 'left: -1.1rem;' : 'left: -3.2rem;'">
							{{type == 1 ? '登录' : type == 2 ? '完善信息' : '选择试卷'}}
						</div>
					</div>
				</div>
				<div v-if="type == 1">
					<div style="margin-top: 39.78px;" v-if="!loginType">
						<div style="position: relative;">
							<el-input class="login-input" v-loading="loading" placeholder="请输入手机号码" v-model="phone"
								:disabled="step == 2" style="text-align: center; font-family: PingFang SC-Regular;"
								maxlength="11" @input="changePhone">
							</el-input>
							<i v-if="step == 2" @click="reset()" class="el-icon-edit-outline phone-edit-icon"
								style="font-size: 1.3rem; color:var(--main-primary-color);"></i>
						</div>
					</div>
					<div v-show="step == 2 && !loginType">
						<el-input class="login-input" placeholder="短信验证码" v-model="smsCode" @input="changeCode"
							style="text-align: center;  font-family: PingFang SC-Regular;margin-top: 13px;"
							maxlength="6">
						</el-input>
						<div class="sms-code-area">
							<div class="sms-code-error"></div>
							<div class="sms-code-get sms-code-get__available" @click="getCode">{{ smsCodeGet }}</div>
						</div>
					</div>
					<div style="margin-top: 39.78px;" v-if="loginType">
						<div style="position: relative;">
							<el-input class="login-input" v-loading="loading" placeholder="请输入卡密" v-model="cardNum"
								style="text-align: center; font-family: PingFang SC-Regular;" maxlength="9">
							</el-input>
						</div>
					</div>
					<div class="sms-code-area">
						<div class="sms-code-get sms-code-get__available" @click="cardLogin">
							{{!loginType ? '卡密登录' : '手机号登录'}}
						</div>
					</div>
					<el-button class="login-btn" @click="login">登录</el-button>
				</div>
				<!-- 需要完善信息 -->
				<div style="margin-top: 39.78px;" v-if="type == 2">
					<div style="position: relative;">
						<el-input class="login-input" placeholder="请输入姓名" v-model="student_name"
							style="text-align: center; font-family: PingFang SC-Regular;" maxlength="11">
						</el-input>
					</div>
					<div style="margin-top:10px">
						<el-select style="width: 22.38rem;height: 3.75rem;" size="medium" v-model="class_id"
							@change="classChange" placeholder="请选择" v-if="class_list && class_list.length >= 1">
							<el-option v-for="(item,index) of class_list" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<el-button class="login-btn" @click="saveUser">登录</el-button>
				</div>
				<div style="margin-top: 39.78px;" v-if="type == 3">
					<div style="position: relative;">
						<el-input class="login-input" placeholder="请输入姓名" v-model="student_name"
							style="text-align: center; font-family: PingFang SC-Regular;" maxlength="11">
						</el-input>
					</div>
					<div style="margin-top:10px">
						<el-select style="width: 22.38rem;height: 3.75rem;" size="medium" v-model="class_id"
							@change="classChange" placeholder="请选择" v-if="class_list && class_list.length >= 1">
							<el-option v-for="(item,index) of class_list" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<el-button class="login-btn" @click="saveUsers">登录</el-button>
				</div>
			</div>
		</div>
		<div class="footer">
			<div class="footer-item">©2016-2024 {{ pageData.corporate_name }}</div>
			<div class="footer-item"><a href="https://beian.miit.gov.cn/" target="_blank"
					style="text-decoration: none; color: #FFF;">{{ pageData.record_number }}</a></div>
		</div>
	</div>
</template>

<script>
	var timer;
	export default {
		computed: {
			pageData() {
				if (this.$store.state.pageData && this.$store.state.pageData.title) {
					document.title = this.$store.state.pageData.title;
				}
				return this.$store.state.pageData; // 访问Vuex Store的计数器状态
			},
		},
		data() {
			return {
				student_name: '',
				class_list: [],
				class_id: '', // 1理科 2文科
				exam_id: '',
				classItem: {},
				phone: '',
				smsCode: '',
				step: 1,
				loading: false,
				type: 1,
				smsCodeGet: '发送验证码',
				loginType: true,
				cardNum: ''
			}
		},
		mounted() {
			if (this.$route.query.type && this.$route.query.type == 2 || this.$route.query.type == 3) {
				this.type = this.$route.query.type;
				this.phone = localStorage.getItem('phone');
				this.cardNum = this.phone;
				this.smsCode = '2019'
				this.login()
			}
		},
		methods: {
			// 切换登录方式
			cardLogin() {
				this.loginType = !this.loginType;
			},
			changeCard() {

			},
			changeCode() {
				if (this.smsCode.length == 6) {
					this.login();
				}
			},
			changePhone(e) {
				if (e.length == 11) {
					this.loading = true;
					this.getCode();
				}
			},
			reset() {
				this.step = 1;
				this.smsCodeGet = '发送验证码';
				this.loading = false;
				clearInterval(timer);
			},
			getCode() {
				let {
					phone
				} = this;
				let params = {
					phone
				}
				if (this.smsCodeGet != '发送验证码') {
					return false;
				}
				this.$request.get('/sike.php/exam/sendSms', {
						params
					}).then(res => {
						if (res.code == 200) {
							// 发送短信倒计时
							let count = 59;
							timer = setInterval(() => {
								if (count > 0) {
									this.smsCodeGet = count + 's后重新获取';
									count--;
								} else {
									clearInterval(timer);
									this.smsCodeGet = '发送验证码';
								}
							}, 1000);
							this.step = 2;
						} else {
							this.$notify.error({
								title: '错误',
								message: res.message
							});
						}
						this.loading = false;
					})
					.catch(err => {
						this.loading = false
						console.error('请求失败:', err);
					});
			},
			classChange(e) {
				this.class_list.forEach((item) => {
					if (item.id == e) {
						this.classItem = item
					}
				})
			},
			saveUsers() {
				localStorage.setItem('token', this.classItem.token);
				localStorage.setItem('phone', this.classItem.phone);
				if (this.classItem.token && this.classItem.phone) {
					this.$router.push('/');
				}
			},
			saveUser() {
				if (this.exam_id == 8) {
					localStorage.setItem('token', this.classItem.token);
					localStorage.setItem('phone', this.classItem.phone);
					this.$request.post('/sike.php/exam/saveUser', {
						student_name: this.student_name
					}).then(res => {
						if (res.code == 200) {
							this.$router.push('/');
						} else {
							this.$notify.error({
								title: '错误',
								message: res.message
							});
						}
					})
					return
				}
				let {
					student_name,
					class_id
				} = this;
				let params = {
					student_name,
					class_id
				}
				this.$request.post('/sike.php/exam/saveUser', params).then(res => {
					if (res.code == 200) {
						if (this.exam_id == 10) {
							this.type = 3;
							this.class_id = '';
							this.class_list = res.data;
						} else {
							this.$router.push('/');
						}
					} else {
						this.$notify.error({
							title: '错误',
							message: res.message
						});
					}
				})
			},
			login() {
				let {
					phone,
					smsCode,
					loginType,
					cardNum
				} = this;
				let params = {
					phone,
					code: smsCode
				}
				if (loginType) {
					params = {
						phone:cardNum,
						code:2019,
					}
				}
				this.$request.post('/sike.php/exam/login', params).then(res => {
						if (res.code == 200) {
							if (res.data.exam_id == 8) {
								this.student_name = res.data.student_name;
								this.exam_id = res.data.exam_id;
								this.type = 2;
								this.student_name = res.data.student_name;
								this.class_list = res.data.class_list;
								return
							}
							if (res.data.exam_id == 10) {
								this.student_name = res.data.student_name;
								this.exam_id = res.data.exam_id;
								this.type = 3;
								this.student_name = res.data.student_name;
								this.class_list = res.data.class_list;
								return
							}
							let {
								token,
								phone
							} = res.data;
							localStorage.setItem('token', token);
							localStorage.setItem('phone', phone);
							this.$router.push('/');
						} else if (res.code == 201) {
							let {
								token,
								phone,
								class_list
							} = res.data;
							this.exam_id = res.data.exam_id;
							this.class_list = class_list;
							localStorage.setItem('token', token);
							localStorage.setItem('phone', phone);
							this.type = 2;
						} else {
							this.$notify.error({
								title: '错误',
								message: res.message
							});
						}
					})
					.catch(err => {
						console.error('请求失败:', err);
					});
			},
		}
	}
</script>

<style>
	.fill-form {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center
	}

	.fill-form .fill-form__title {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 1.87rem 0
	}

	.fill-form .fill-form__title .fill-form-title__text {
		font-size: 1.25rem;
		font-weight: 700;
		color: #545454;
		line-height: 1.46rem;
		letter-spacing: 8px
	}

	.fill-form .fill-form__title .fill-form-title__icon {
		width: 1.38rem;
		height: 1.38rem;
		margin-right: 1.13rem
	}

	.fill-form .fill-input {
		width: 22.38rem;
		height: 3.31rem;
		--el-input-border-radius: 3.63rem;
		--el-input-border-color: rgba(0, 0, 0, .26);
		font-size: 1.13rem;
		font-weight: 700;
		color: #c6c6c6
	}

	.fill-form .confirm-btn {
		margin-top: 1.88rem;
		width: 22.38rem;
		height: 3.75rem;
		border-radius: 5.25rem;
		background: #587aff;
		font-size: 1.25rem;
		color: #fff;
		cursor: pointer
	}

	.fill-form .confirm-btn:hover {
		background: #214dff;
		transition: all .3s
	}

	.fill-cascader .el-input {
		width: 22.38rem;
		height: 3.31rem;
		--el-input-border-radius: 3.63rem;
		--el-input-border-color: rgba(0, 0, 0, .26);
		font-size: 1.13rem;
		font-weight: 700;
		color: #c6c6c6
	}

	.fill-cascader .el-input .el-input__inner {
		text-align: left;
		font-family: PingFang SC-Regular;
		padding-left: 1.87rem
	}

	.xk-checkbox-group {
		width: 22.49rem;
		display: flex;
		justify-content: left;
		flex-wrap: wrap;
		row-gap: .94rem;
		column-gap: .81rem;
		-webkit-user-select: none;
		user-select: none
	}

	.xk-checkbox-group .el-checkbox {
		margin-right: 0
	}

	.xk-checkbox-group .is-bordered {
		border: .06rem solid
	}

	.xk-checkbox-group .is-checked {
		border: .13rem solid
	}

	.xk-checkbox-group .el-checkbox--small {
		width: 5rem;
		height: 2.19rem;
		border-radius: 3.56rem !important;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 !important
	}

	.xk-checkbox-group .el-checkbox--small .el-checkbox__input {
		display: none
	}

	.xk-checkbox-group .el-checkbox--small .el-checkbox__label {
		padding-left: 0 !important;
		font-size: 1.13rem !important
	}

	.km-select {
		width: 22.44rem;
		height: 3.25rem;
		background: #fff;
		box-shadow: 0 0 1.25rem #16348617;
		border-radius: 5.25rem;
		display: flex;
		align-items: center;
		position: relative;
		z-index: 1
	}

	.km-select .km-select__item {
		width: 11.22rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.25rem;
		z-index: 3;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		height: 100%
	}

	.km-select .km-select__item .km-select-item__icon {
		width: 1.38rem;
		height: 1.38rem;
		margin-right: .69rem
	}

	.km-select .lk,
	.km-select .wk {
		color: #c6c6c6
	}

	.km-select .slide-box {
		position: absolute;
		left: 0;
		top: 0;
		width: 11.25rem;
		height: 3.25rem;
		background: #587aff;
		border-radius: 5.25rem;
		opacity: 1;
		z-index: 2;
		transition: .3s all
	}

	.km-select_is-wk .lk {
		color: #c6c6c6
	}

	.km-select_is-wk .wk {
		color: #fff
	}

	.km-select_is-wk .slide-box {
		left: 11.25rem;
		transition: .3s all
	}

	.km-select_is-lk .lk {
		color: #fff
	}

	.km-select_is-lk .wk {
		color: #c6c6c6
	}

	.km-select_is-lk .slide-box {
		left: 0rem;
		transition: .3s all
	}

	.login-form {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center
	}

	.login-form .login-title {
		margin-top: 3.06rem
	}

	.login-form .login-title .decorator-line {
		position: absolute;
		top: 0;
		left: -11rem;
		width: 22.38rem;
		height: .19rem
	}

	.login-form .login-title .title {
		position: absolute;
		top: -1rem;
		font-size: 1.38rem;
		font-weight: 600;
		color: #545454;
		letter-spacing: 7px;
		width: 8rem
	}

	.login-form .login-input {
		width: 22.38rem;
		height: 3.75rem;
		font-size: 1.25rem;
		/* font-weight: 700; */
		color: #c6c6c6
	}

	.login-form .login-radio {
		/* width: 11.15rem; */
		flex: 1;
		height: 3.75rem;
		font-size: 1.25rem;
		/* font-weight: 700; */
		color: #c6c6c6
	}

	.login-form .login-radio .el-radio-button__inner {
		height: 3.75rem;
		font-size: 1.25rem;
		line-height: 3.75rem;
		padding: 0;
		width: 100%;
		/* border-radius: 3.63rem; */
	}

	.login-form .login-input .el-input__inner {
		border-radius: 3.63rem;
		border-color: rgba(0, 0, 0, .26);
		text-align: center;
		height: 3.75rem;
		font-size: 1.25rem;
		/* font-weight: 700; */
		color: #606266
	}

	.login-form .phone-edit-icon {
		position: absolute;
		top: 1.3rem;
		right: 1.5rem;
		cursor: pointer
	}

	.login-form .phone-error {
		width: 22.38rem;
		text-align: center;
		margin-top: 5px;
		font-family: var(--main-font-bold);
		color: var(--main-error-color)
	}

	.login-form .login-btn {
		margin-top: 2rem;
		width: 22.38rem;
		height: 3.75rem;
		border-radius: 5.25rem;
		background: #587aff;
		font-size: 1.25rem;
		color: #fff;
		cursor: pointer
	}

	.login-form .login-btn[data-v-d0549bc8]:hover {
		background: #214dff;
		transition: all .3s
	}

	.login-form .sms-code-area {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 5px;
		-webkit-user-select: none;
		user-select: none;
		width: 100%;
	}

	.login-form .sms-code-area .sms-code-error {
		font-size: 1rem;
		font-family: var(--main-font-bold);
		font-weight: 400;
		color: var(--main-error-color);
		margin-left: 5px;
	}

	.login-form .sms-code-area .sms-code-get {
		font-size: 1rem;
		color: var(--main-info-color)
	}

	.login-form .sms-code-area .sms-code-get__available {
		color: var(--main-primary-color);
		font-family: var(--main-font-bold);
		cursor: pointer
	}

	@keyframes customFadeInDown-ebfa81d2 {
		0% {
			opacity: 0;
			transform: translateY(-100px)
		}

		to {
			opacity: 1;
			transform: translateY(0)
		}
	}

	.animate__customFadeInDown {
		animation-name: customFadeInDown-ebfa81d2
	}

	.login {
		position: relative;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.login .background-img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		z-index: -1
	}

	.login .title {
		position: absolute;
		top: 7.63rem;
		left: 9.25rem;
		font-size: 4.38rem;
		font-family: Source Han Sans CN-Bold;
		color: #FFF;
		letter-spacing: .38rem
	}

	.login .title-line {
		position: absolute;
		top: 15.25rem;
		left: 9.25rem;
		width: 6.5rem;
		height: .69rem;
		background-color: #FFF
	}

	.login .login-box {
		position: absolute;
		right: 12.19rem;
		width: 32.25rem;
		min-height: 29.31rem;
		background: #f9fbfd;
		box-shadow: 10px 10px 30px #181c750d;
		border-radius: 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 2.5rem 0
	}

	.login .login-box .logo {
		width: 10.06rem;
		/* height: 1.75rem */
	}

	.login .login-box .comming-img {
		width: 23.25rem;
		margin-top: 2rem
	}

	.login .login-box .comming-text {
		margin-top: -1.5rem;
		font-size: 1.38rem;
		font-family: var(PingFang SC-Bold);
		color: #838383;
		line-height: 1.61rem
	}

	.login .footer {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 3rem;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.login .footer .footer-item {
		font-size: 1rem;
		font-family: PingFang SC-Regular;
		font-weight: 400;
		color: #FFF;
		margin-right: 1.1rem
	}

	@media screen and (max-width: 768px) {
		.login {
			flex-direction: column;
			padding: 0 2rem
		}

		.login .title {
			position: unset;
			font-size: 2.4rem;
			letter-spacing: .28rem;
			margin-bottom: 3rem
		}

		.login .title-line {
			display: none
		}

		.login .login-box {
			position: unset;
			width: 100%
		}
	}

	.el-select {
		height: 3.75rem;

	}

	.el-select .el-input {
		height: 3.75rem;
	}

	.el-select .el-input .el-input__inner {
		height: 3.75rem;
		font-size: 1.25rem;
		text-align: center;
		border-radius: 200px;
	}

	/* 下面设置右侧按钮居中 */
	.el-input__suffix {
		top: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: nowrap;
		flex-direction: row;
		align-content: flex-start;
		font-size: 1.25rem;
	}

	.el-select__caret {
		font-size: 1.25rem;
	}


	.el-input__icon {
		line-height: 62px;
	}

	.el-scrollbar .el-select-dropdown__item {
		font-size: 1.25rem;
		height: 3rem;
		line-height: 3rem;
	}
</style>